// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function useDelayedHover(enabledOpt, delay, onHover) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var hoverTimeout = React.useRef(undefined);
  var $$clearTimeout$1 = function (param) {
    Belt_Option.forEach(hoverTimeout.current, function (timeout) {
      clearTimeout(timeout);
      hoverTimeout.current = undefined;
    });
  };
  var handleMouseEnter = Belt_Option.map(onHover, function (onHover, $$event) {
    $$clearTimeout$1(undefined);
    if (enabled) {
      hoverTimeout.current = Caml_option.some(setTimeout(function (param) {
        Curry._1(onHover, $$event);
      }, delay));
      return;
    } else {
      return Curry._1(onHover, $$event);
    }
  });
  var handleMouseLeave = function (param) {
    $$clearTimeout$1(undefined);
  };
  React.useEffect(function () {
    return $$clearTimeout$1;
  }, []);
  return {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  };
}
export { useDelayedHover };
/* react Not a pure module */